module.exports = __webpack_public_path__ + "img/main-list_01.0414a98e.jpg";